<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M6 11.293l8-8 .707.707L6 12.707 1.293 8 2 7.293z"/>
</svg>
